// ─────────────────────────────────────────────────────────────────────────────
// i18n/locales/es.ts – Español
// ─────────────────────────────────────────────────────────────────────────────
export default {
  lang: { de: 'Deutsch', fr: 'Français', it: 'Italiano', en: 'English', es: 'Español', pt: 'Português' },

  nav: {
    // Menuepunkt der Uebersichtsseite (T-M41.3) — eigener Schluessel neben
    // `nav.dashboard`, das zwei andere Stellen beschriftet.
    overview:     'Resumen',
    dashboard:    'Panel',
    jobs:         'Trabajos de impresión',
    fleet:        'Flota',
    printers:     'Impresoras',
    schankanlage: 'Sistema de bebidas',
    printserver:  'Servidor de impresión',
    settings:     'Configuración',
    users:        'Usuarios',
    company:      'Empresa',
    locations:    'Ubicaciones',
    smtp:         'Correo SMTP',
    api:          'API',
    switchCompany:'Cambiar empresa',
    selectCompany:'Seleccionar empresa',
    logout:       'Cerrar sesión',
  },

  common: {
    save:          'Guardar',
    saving:        'Guardando …',
    cancel:        'Cancelar',
    delete:        'Eliminar',
    deleting:      'Eliminando …',
    edit:          'Editar',
    add:           'Añadir',
    back:          'Volver',
    loading:       'Cargando …',
    search:        'Buscar …',
    yes:           'Sí',
    no:            'No',
    confirm:       'Confirmar',
    confirmDelete: '¿Realmente eliminar?',
    cannotUndo:    'Esta acción no se puede deshacer.',
    new:           'Nuevo',
    optional:      '(opcional)',
    unknown:       '—',
    active:        'Activo',
    inactive:      'Inactivo',
    enabled:       'Habilitado',
    disabled:      'Deshabilitado',
    seconds:       'seg.',
    minutes:       'min.',
    noData:        'No hay datos disponibles.',
    close:         'Cerrar',
    remove:        'Eliminar',
    copy:          'Copiar',
    copied:        '¡Copiado!',
    change:        'Cambiar',
    send:          'Enviar',
    sending:       'Enviando …',
    processing:    'Procesando …',
    show:          'Mostrar',
    hide:          'Ocultar',
    yesDelete:     'Sí, eliminar',
    yesRemove:     'Sí, quitar',
    note:          'Nota',
    error:         'Error',
    version:       'Versión',
    // Kennzahl, die NICHT serverseitig gezaehlt ist: Untergrenze (REQ-OPS-034)
    count: {
      atLeast:      'Al menos {count}',
      atLeastShort: '≥ {count}',
      atLeastHint:  'Derivado de la lista cargada: al menos estos, posiblemente más.',
    },
    // Blaettern statt Kuerzen (REQ-OPS-032/033, T-M8.19b) — die zwei Texte,
    // die in JEDER geblaetterten Liste gleich lauten.
    pagination: {
      liveFirstPageOnly: 'Solo la primera página se actualiza en directo.',
      loadFailed:        'Error al cargar más elementos.',
    },
  },

  status: {
    online:   'En línea',
    offline:  'Sin conexión',
    printing: 'Imprimiendo',
    error:    'Error',
    ready:    'Listo',
    pending:  'Pendiente',
    done:     'Completado',
    // Estado de entrega `completed` (REQ-DM-040) — véase de.ts.
    completed: 'Entregado',
    failed:   'Fallido',
    expired:  'Caducado',
  },

  role: {
    admin:    'Administrador',
    user:     'Usuario',
  },

  auth: {
    email:              'Dirección de correo',
    password:           'Contraseña',
    passwordNew:        'Nueva contraseña',
    passwordNewLabel:   'Nueva contraseña *',
    passwordConfirm:    'Confirmar contraseña',
    passwordConfirmLabel:'Confirmar contraseña *',
    passwordMinHint:    'Mínimo 8 caracteres',
    passwordRepeat:     'Repetir contraseña',
    passwordMismatch:   'Las contraseñas no coinciden.',
    passwordTooWeak:    'La contraseña es demasiado débil (mínimo 8 caracteres).',
    passwordSave:       'Guardar contraseña',
    passwordSaved:      '¡Contraseña guardada!',
    passwordSavedHint:  'Su contraseña ha sido cambiada correctamente. Será redirigido automáticamente …',
    toDashboard:        'Ir al panel',
    linkInvalid:        'Enlace no válido',
    linkInvalidHint:    'Este enlace ha caducado o ya ha sido utilizado. Por favor, solicite un nuevo enlace.',
    toLogin:            'Ir al inicio de sesión',
    setNewPassword:     'Establecer nueva contraseña',
    setNewPasswordHint: 'Introduzca su nueva contraseña para',
    welcomeBack:        'Bienvenido de nuevo',
    welcomeHint:        'Inicie sesión con su cuenta.',
    login:              'Iniciar sesión',
    loggingIn:          'Iniciando sesión …',
    logout:             'Cerrar sesión',
    forgotPassword:     '¿Olvidó su contraseña?',
    resetPassword:      'Restablecer contraseña',
    resetSent:          'Correo enviado. Por favor revise su bandeja de entrada.',
    backToLogin:        'Volver al inicio de sesión',
    sessionExpired:     'Su sesión ha expirado (12 horas). Por favor, inicie sesión de nuevo.',
    footer:             'Payfix AG · Sistema de gestión de impresión · v1.0',
    strength: {
      weak:      'Débil',
      medium:    'Media',
      strong:    'Fuerte',
      veryStrong:'Muy fuerte',
    },
    errors: {
      invalidEmail:    'Dirección de correo no válida.',
      wrongPassword:   'Contraseña incorrecta.',
      userNotFound:    'No se encontró ningún usuario con este correo.',
      tooManyRequests: 'Demasiados intentos. Por favor espere.',
      generic:         'Error al iniciar sesión. Por favor inténtelo de nuevo.',
      occurred:        'Ha ocurrido un error.',
    },
  },

  invitation: {
    title:        'Aceptar la invitación',
    subtitle:     'Establezca su contraseña para crear su cuenta.',
    submit:       'Crear cuenta',
    working:      'Creando la cuenta …',
    successTitle: 'Su cuenta está lista',
    successHint:  'Se está iniciando sesión y será redirigido …',
    errInvalid:   'Esta invitación no es válida. Solicite una nueva invitación.',
    errExpired:   'Esta invitación ha caducado. Solicite una nueva invitación.',
    errExists:    'Ya existe una cuenta para esta dirección. Inicie sesión con su contraseña actual.',
    errFailed:    'No se pudo aceptar la invitación. No se creó nada; inténtelo de nuevo.',
  },

  bootstrap: {
    errorTitle: 'El inicio ha fallado',
    errorHint:  'No se ha podido completar el inicio de sesión. Vuelva a intentarlo o inicie sesión de nuevo.',
    errorHintNoProfile: 'No existe ningún perfil de usuario para esta cuenta. Póngase en contacto con su administrador.',
    errorCode:  'Código de error: {code}',
    retry:      'Reintentar',
    reLogin:    'Iniciar sesión de nuevo',
  },

  // T-M21.5 / REQ-OPS-054: el aviso NOMBRA las áreas afectadas y no muestra
  // NINGUNA hora — la hora de la última actualización recibida no se registra.
  liveVerbindung: {
    title:     'Actualización en directo interrumpida',
    areas:     'Ya no está en directo: {areas}',
    hint:      'Los datos mostrados proceden de la última actualización recibida y pueden estar obsoletos. Solo se volverán a actualizar cuando se restablezca la conexión.',
    reconnect: 'Volver a conectar',
    quiet:     'Conexión interrumpida: {areas}',
    area: {
      jobs:         'Trabajos de impresión',
      printers:     'Impresoras',
      printservers: 'Servidores de impresión',
      companies:    'Empresas',
      locations:    'Ubicaciones',
      registers:    'Cajas',
      users:        'Usuarios',
      apiTokens:    'Tokens de API',
    },
  },

  fleet: {
    title:          'Flota',
    subtitle:       'Servidores de impresión por ubicación – estado, versión y colas en vivo.',
    empty:          'Aún no hay servidores de impresión',
    emptyHint:      'En cuanto se configure un servidor de impresión, aparecerá aquí.',
    noLocation:     'Sin ubicación',
    noServers:      'Ningún servidor de impresión en esta ubicación',
    noPrinters:     'Sin impresoras',
    unassignedPrinters: {
      text:   'Una impresora espera una asignación | {count} impresoras esperan una asignación',
      hint:   'Estas impresoras se crearon a través de la interfaz y no tienen ningún servidor de impresión asignado. No aparecen en ningún grupo de esta vista y solo aceptarán trabajos cuando se les asigne un servidor de impresión.',
      action: 'Asignar en la lista de impresoras',
    },
    locationOffline:'Ubicación sin conexión',
    serverCount:    '{n} servidores de impresión',
    version:        'Versión',
    versionUnknown: 'Desconocida',
    versionOutlier: 'Discrepante',
    versionOutlierHint: 'Difiere de la versión de la flota v{version}.',
    lastPing:       'Última señal de vida',
    pending:        '{n} en espera',
    queueEmpty:     'Sin trabajos en espera',
    pendingAtLeast: 'Al menos {n} en espera',
    queueUnknown:   'Cola desconocida',
    queueUnknownHint: 'No se pudo contar la cola. Eso no significa que esté vacía.',
    queueHeldHeading: 'Retenidos ({n})',
    queueHeldHint:    'Estos trabajos solo se imprimen cuando la cocina los marca como «Listo para recoger». Por eso no tienen posición en la cola.',
    queueNoneWaiting: 'Nada espera a la impresora',
    time: {
      never:        'Nunca',
      justNow:      'Ahora mismo',
      minutes:      'Hace {n} min',
      hours:        'Hace {n} h',
      days:         'Hace {n} días',
    },
  },

  dashboard: {
    title:          'Panel',
    welcome:        'Bienvenido',
    totalJobs:      'Trabajos en total',
    totalPrinters:  'Total de impresoras',
    onlinePrinters: 'Impresoras en línea',
    printservers:   'Servidores de impresión',
    recentJobs:     'Trabajos de impresión recientes',
    noJobs:         'No hay trabajos de impresión disponibles.',
    heldJobs:       'Retenidos',
    heldJobsHint:   'Estas comandas solo se imprimen cuando la cocina las marca como «Listo para recoger». No esperan a la impresora y no son un atasco.',
  },

  printers: {
    title:         'Impresoras',
    subtitle:      'Todas las impresoras conectadas de esta empresa',
    add:           'Añadir impresora',
    empty:         'Aún no hay impresoras creadas',
    emptyHint:     'Añada la primera impresora de esta empresa.',
    number:        'N.º',
    name:          'Nombre',
    type:          'Tipo',
    printserver:   'Servidor de impresión',
    ipAddress:     'Dirección IP',
    pendingBons:   'Tickets abiertos',
    deleteTitle:   '¿Eliminar impresora?',
    deleteConfirm: '¿Desea realmente eliminar {name}?',
    new:           'Nueva impresora',
    edit:          'Editar',
    openKitchen:      'Abrir Kitchen TV',
    openAbholscreen:  'Abrir pantalla de recogida',
    openFastline:     'Abrir Fastline',
    // BERICHTIGT AM 2026-08-17 (T-M8.19b, REQ-OPS-032 neu gefasst): der
    // Schluessel bleibt, sein Wortlaut wird berichtigt statt geloescht. Bis
    // dahin sagte er „die Liste ist gekuerzt, weitere Drucker sind hier nicht
    // sichtbar" — eine Sackgasse. Die 100 sind ab jetzt die SEITENgroesse.
    limitReached:     'Hay más impresoras de esta empresa: se carga una página de {count} entradas — cargar más.',
    loadMore:         'Cargar {count} impresoras más',
    // Kurzform fuer das Nachladen IM Auswahlkontext (Drucker-Dropdown der
    // Auftragsliste): dort ist kein Platz fuer die Seitengroesse.
    loadMoreShort:    'Cargar más impresoras …',
    loadedCount:      '{count} impresoras cargadas',
    endOfList:        'Fin de la lista – todas las impresoras están cargadas.',
    sections: {
      basic:       'Datos básicos',
      abholscreen: 'Configuración de pantalla de recogida',
      kitchenTv:   'Configuración de Kitchen TV',
      alarm:       'Alertas',
      status:      'Estado',
      screenAccess: 'Clave de pantalla',
    },
    fields: {
      outputType:        'Tipo de salida',
      outputPrint:       'Impresora',
      outputKitchenTv:   'Kitchen TV / Pantalla',
      outputPrintHint:   'Impresora ESC/POS física con dirección y tipo de modelo.',
      outputKitchenTvHint: 'Canal de pantalla sin servidor de impresión, dirección ni tipo de modelo.',
      port:              'Puerto',
      abholscreenEnabled: 'Pantalla de recogida activa',
      abholscreenEnabledHint: 'Muestra los números de pedido listos en la pantalla de recogida.',
      displayDurationHint: 'Duración de visualización de pedidos listos, de 5 a 600 segundos (predeterminado 60 segundos).',
      autoCompleteDisabled:     'Desactivar el cierre automático',
      autoCompleteDisabledHint: 'Los pedidos listos permanecen visibles hasta que se cierran a mano — la duración de visualización ya no los cierra. Cuatro horas después de su entrada se cierran automáticamente de todos modos; esa limpieza no se puede desactivar.',
      maxItems:          'Máx. números mostrados',
      maxItemsUnit:      'números',
      maxItemsHint:      'Límite de números mostrados simultáneamente (0 = ilimitado).',
      screenKeyHint:       'La clave de pantalla registra una pantalla (Kitchen TV, pantalla de recogida, Fastline). Solo se guarda el hash; el texto no se puede recuperar después.',
      screenKeySaveFirst:  'Guarde primero el canal, luego podrá establecer una clave de pantalla.',
      screenKeySet:        'Clave de pantalla establecida',
      screenKeyNotSet:     'Sin clave de pantalla',
      screenKeyPlaceholder:'Introducir o generar clave',
      screenKeyGenerate:   'Generar',
      screenKeySave:       'Establecer clave',
      screenKeyRotate:     'Rotar clave',
      screenKeyOnce:       'Esta clave se muestra solo UNA vez. Anótela ahora de forma segura.',
      screenKeyRequired:        'Exigir clave de pantalla',
      screenKeyRequiredHint:    'Una pantalla inicia sesión en este canal con la clave de pantalla. Sin ella no obtiene acceso.',
      screenKeyRequiredOffHint: 'Este canal está abierto sin clave de pantalla: quien conozca la dirección de la pantalla lee los pedidos de este canal y cambia su estado de preparación. El acceso sigue limitado a este canal y a esta empresa.',
      screenKeyRequiredOffPrintHint: 'En este canal eso también provoca una impresión: quien ponga un pedido en «Listo para recoger» libera el ticket de trabajo retenido, y este se imprime.',
      alarmEnabled:      'Alertas activas',
      alarmEnabledHint:  'Notifica ante problemas de la impresora (sin conexión, error).',
      alarmMuted:        'Silenciar por completo',
      alarmMutedHint:    'Suprime todas las alertas de esta impresora.',
      alarmStages:       'Niveles de alerta',
      stage_offline:     'Sin conexión',
      stage_paperLow:    'Papel casi agotado',
      stage_error:       'Error',
      stage_coverOpen:   'Tapa abierta',
      // Stufe Papierende (T-M42.3, REQ-PS-023c) und Kennzeichnung unwirksamer
      // Stufen je Modelltyp (REQ-PS-023a Praez. 1 (a) / Praez. 3).
      stage_paperOut:    'Sin papel',
      stageIneffective:  'sin efecto',
      stageIneffectiveTitle: 'El tipo de modelo {model} no informa de este estado. El nivel puede activarse, pero nunca genera una alerta en esta impresora.',
      stagesIneffectiveHint: 'Los niveles marcados «sin efecto» no los informa el tipo de modelo {model}: pueden activarse, pero nunca generan una alerta en esta impresora.',
      // T-M42.10 Teil (b): die gesetzten Stufen wuerden mangels Einrichtung
      // am Mandanten nie versendet (Regel: utils/alarmEinrichtung.ts).
      alarmNotSetUpTypeDisabled: 'Alarmas no configuradas: en el centro de alarmas de la empresa «Fallo de impresora» está desactivado. Los niveles definidos aquí nunca se envían.',
      alarmNotSetUpNoRecipients: 'Alarmas no configuradas: en el centro de alarmas de la empresa no hay ningún destinatario. Los niveles definidos aquí nunca se envían.',
      printerId:         'ID de impresora',
      printerIdPlaceholder: 'p. ej. 3324',
      printerIdHint:     'El ID de impresora del portal de Payfix — exactamente el valor que la caja envía como printer_id. No es un número de libre elección: sin el ID correcto ningún ticket llega a este canal.',
      designation:       'Nombre',
      printerType:       'Tipo de impresora',
      printerServer:     'Servidor de impresión',
      ipAddress:         'Dirección IP',
      sameAddressHint:   'Misma dirección que «{name}». Ambos canales imprimen uno tras otro en el mismo dispositivo.',
      company:           'Empresa',
      range:             'Desde / Hasta',
      rangeFrom:         'Desde',
      rangeTo:           'Hasta',
      tableRangesHint:   'Si hay rangos definidos, este canal solo recibe las comandas y los recibos cuyo número de mesa esté dentro de uno de los rangos. Esto vale también para el Kitchen TV, la pantalla de recogida y Fastline. Los documentos sin número de mesa – entre ellos los cierres diarios y las liquidaciones del personal – llegan siempre a este canal. Si no hay ningún rango definido, lo recibe todo.',
      qrCode:            'Imprimir código QR',
      qrCodeHint:        'Añade un código QR en el ticket. También es el requisito para que los pedidos aparezcan en la pantalla de recogida de esta impresora.',
      qrCodeOffByKitchenTv: 'El código QR del ticket permanece desactivado mientras la vista Kitchen TV esté activada: ambos nunca están activos a la vez en la misma impresora. Activarlo aquí desactiva la vista Kitchen TV.',
      qrCodeOffByU220: 'La TM-U220 no imprime códigos QR. En este modelo el interruptor está bloqueado y no tiene efecto.',
      showName:          'Mostrar nombre de impresora',
      colorWorking:      'Color en proceso',
      colorReady:        'Color listo para recoger',
      displayDuration:   'Duración de visualización',
      preview:           'Vista previa',
      kitchenTvEnabled:  'Kitchen TV',
      kitchenTvEnabledHint: 'Muestra además los pedidos de esta impresora en una pantalla Kitchen TV. La impresora sigue siendo una impresora completa y continúa imprimiendo. Al activarla se desactiva el código QR del ticket.',
      autoStartTimer:    'Iniciar temporizador automáticamente',
      autoStartTimerHint:'Inicia el temporizador automáticamente al recibir un pedido',
      disablePrintingWhenKitchenTv:     'No imprimir las comandas',
      disablePrintingWhenKitchenTvHint: 'Las comandas de este canal ya no se imprimen, solo se muestran en el Kitchen TV. Se consideran entregadas de inmediato y aparecen en la lista de trabajos con la nota «entregado sin impresión». Los tickets de caja se siguen imprimiendo. En un canal de solo pantalla el ajuste no tiene efecto, porque allí nunca se imprime.',
      fastline:          'Fastline',
      rangeRemove:       'Eliminar rango {n}',
      abholscreenUrl:    'URL de pantalla de recogida',
      kitchenTvUrl:      'URL Kitchen TV',
      kitchenTvUrlLight: 'URL Kitchen TV Light',
      fastlineUrl:       'URL Fastline',
    },
    // Der aktive Bildschirm-Modus, angezeigt statt eingestellt
    // (REQ-SC-106 (2), T-M25.5). Die drei Modusnamen sind Produktnamen und
    // stehen in allen sechs Sprachen gleich; die Feldwerte bleiben
    // technisch-englisch (REQ-OV-002, REQ-DM-068 (1)).
    screenMode: {
      label:    'Modo activo',
      hint:     'Muestra qué pantalla dirige actualmente este canal. El modo se asume en la pantalla misma, no aquí: quien abre una de las tres direcciones confirma allí el cambio y desactiva así el modo anterior.',
      mode_normal:   'Kitchen TV normal',
      mode_light:    'Kitchen TV Light',
      mode_fastline: 'Fastline',
      mode_none:     'ningún modo activo',
    },
    kitchenTvInactive: 'Kitchen TV está desactivado. Actívelo arriba para ajustar la configuración.',
    kitchenTvAlwaysOn: 'Este canal es un canal de pantalla: la vista Kitchen TV funciona siempre aquí y no se puede desactivar.',
    // Druckerzustand: grob (status.*) plus feine Kennungen (REQ-PS-020a/021).
    // Werte bleiben technisch-englisch in Firestore, hier nur die Anzeige.
    status: {
      title:       'Estado actual',
      noDetail:    'Sin incidencias',
      updatedAt:     'Estado sin cambios desde',
      updatedAtHint: 'El momento del último CAMBIO de estado, no el del último aviso. El servidor de impresión escribe este valor solo cuando el estado cambia; una impresora permanentemente sin fallos muestra aquí, por tanto, una hora antigua.',
      never:         'Todavía sin estado comunicado',
      stale: {
        withAge:    'Obsoleto — último aviso hace {age}',
        unknownAge: 'Obsoleto — antigüedad desconocida',
        age: {
          lessThanMinute: 'menos de un minuto',
          minute:  'un minuto',
          minutes: '{n} minutos',
          hour:    'una hora',
          hours:   '{n} horas',
          day:     'un día',
          days:    '{n} días',
        },
        reason: {
          noPrintserver: 'Esta impresora no tiene ningún servidor de impresión asignado. El estado lo escribe exclusivamente el servidor de impresión: sin él, el último valor escrito permanece indefinidamente.',
          noPing:        'El servidor de impresión responsable todavía no ha escrito ninguna señal de vida. Por eso no se puede saber qué antigüedad tiene el estado mostrado.',
          serverOffline: 'El servidor de impresión responsable está desconectado. Ya no puede comunicar el estado de esta impresora; se muestra el último valor escrito.',
          pingTooOld:    'La última señal de vida del servidor de impresión responsable supera el límite de 90 segundos (tres veces el intervalo de 30 segundos). El estado mostrado es el último escrito y puede que ya no sea válido.',
        },
      },
      sourceLabel: 'Origen',
      levelLabel:  'Nivel de detalle',
      levelHint:   'Nivel de detalle que puede indicar este modelo de impresora.',
      detail: {
        offline:     'No accesible',
        coverOpen:   'Tapa abierta',
        paperOut:    'Sin papel',
        cutterError: 'Error del cortador',
        error:       'Error de impresora',
        notResponding: 'No responde',
        paperLow:    'Papel casi agotado',
      },
      source: {
        asb:        'Notificado por la impresora',
        poll:       'Consulta activa',
        jobResult:  'Deducido del resultado de impresión',
        connection: 'Conexión interrumpida',
      },
      level: {
        full:  'Completo',
        basic: 'Limitado',
        none:  'Sin retorno de estado',
      },
    },
    archived:     'Archivada',
    archivedHint: 'Las impresoras archivadas ya no aceptan trabajos.',
    incomplete:     'Incompleta',
    // Corregido el 2026-09-07 (T-M33.3, REQ-DM-072 (h)): desde T-M8.3 los
    // trabajos dirigidos a una impresora sin servidor de impresión se rechazan
    // con 400 — no se aceptan para quedar sin entregar.
    incompleteHint: 'Esta impresora no tiene servidor de impresión de destino. Solo acepta trabajos cuando se le ha asignado un servidor de impresión; hasta entonces, los trabajos enviados se rechazan.',
    filter: {
      all:            'Todas',
      unassigned:     'Sin servidor de impresión ({count})',
      noneUnassigned: 'Todas las impresoras tienen un servidor de impresión asignado.',
    },
    quickAssign: {
      label:       'Asignar servidor de impresión',
      placeholder: 'Asignar servidor de impresión …',
      saving:      'Asignando …',
      failed:      'No se pudo guardar la asignación. Vuelva a intentarlo.',
      noServers:   'No hay ningún servidor de impresión registrado para esta empresa.',
    },
    unassignedNotice: {
      title: 'Sin servidor de impresión asignado',
      body:  'Esta impresora se creó a través de la interfaz y solo acepta trabajos cuando se le asigna un servidor de impresión. Seleccione un servidor de impresión abajo y guarde.',
    },
    validation: {
      nameRequired:         'Introduzca una denominación.',
      numberRequired:       'Introduzca el ID de impresora del portal de Payfix.',
      // NUEVO 2026-09-18 (T-M41.8, REQ-DM-036 Praez. 4 (ix)).
      payfixPrinterIdInvalid: 'Este ID de impresora no se puede guardar. No se admiten la barra inclinada, los valores «.» y «..», los identificadores con la forma «__…__» ni más de 1500 bytes. Introduzca el identificador registrado para esta impresora en el portal de Payfix.',
      payfixPrinterIdTaken: 'El ID de impresora {id} ya está asignado a la impresora «{name}» de la empresa «{company}». Cada ID solo puede existir una vez; de lo contrario el ticket llega al canal equivocado. Introduzca el ID registrado para esta impresora en el portal de Payfix.',
      payfixPrinterIdTakenOtherCompany: 'El ID de impresora {id} ya está asignado a la impresora «{name}» de la empresa «{company}»; es decir, fuera de la empresa seleccionada aquí, y esa impresora no está visible para usted. Cada ID solo puede existir una vez; de lo contrario el ticket llega al canal equivocado. Póngase en contacto con los responsables de «{company}» o introduzca el ID registrado para esta impresora en el portal de Payfix.',
      payfixPrinterIdTakenOtherCompanyUnnamed: 'El ID de impresora {id} ya está asignado en otra empresa. Cuál es esa empresa no se muestra aquí: queda fuera de su acceso. Cada ID solo puede existir una vez; de lo contrario el ticket llega al canal equivocado. Póngase en contacto con el soporte de Payfix o introduzca el ID registrado para esta impresora en el portal de Payfix.',
      payfixPrinterIdTakenOrphaned: 'El ID de impresora {id} ya está asignado a la impresora «{name}», y esa impresora no está asignada a ninguna empresa legible: un ID huérfano. Por eso sigue ocupado en todo el sistema aunque no se encuentre ninguna empresa. Introduzca otro ID registrado en el portal de Payfix y comunique el ID huérfano a explotación.',
      payfixPrinterIdTakenOrphanedUnnamed: 'El ID de impresora {id} ya está ocupado, y la impresora que lo ocupa no está asignada a ninguna empresa legible: un ID huérfano. Por eso sigue ocupado en todo el sistema aunque no se encuentre ninguna empresa. Introduzca otro ID registrado en el portal de Payfix y comunique el ID huérfano a explotación.',
      payfixPrinterIdCheckFailed: 'No se pudo comprobar el ID de impresora: la consulta no está disponible en este momento. No se ha guardado nada. Vuelva a intentarlo en un momento.',
      printserverRequired:  'Seleccione un servidor de impresión. Sin servidor de destino el trabajo no se entrega.',
      modelTypeRequired:    'Seleccione un tipo de modelo (Standard, U220 o Sunmi).',
      ipAddressRequired:    'Introduzca la dirección IP o el nombre de host de la impresora. Sin dirección el servidor de impresión no puede controlarla ni consultar su estado.',
      printserverForbidden: 'Un canal de pantalla no puede tener servidor de impresión.',
    },
    warnings: {
      abholscreenNeedsQrCode:       'La pantalla de recogida permanece vacía en esta impresora: sin la impresión del QR en el ticket no aparece ningún pedido. El QR impreso en el ticket es el comprobante de recogida del cliente. Activar la impresión del QR más tarde solo afecta a los pedidos nuevos — los pedidos ya creados no aparecen retroactivamente.',
      abholscreenNeedsQrCodeAction: 'Activar la impresión del QR en el ticket',
      abholscreenNeedsKitchenTvAction: 'Activar la vista Kitchen TV',
      abholscreenNeedsQrCodeSave:   'Pantalla de recogida activa, impresión del QR en el ticket desactivada: esta pantalla de recogida permanece vacía. Haga clic de nuevo en Guardar para guardar el ajuste de todos modos.',
    },
    notices: {
      displayDurationDisabled:     'Sin efecto: el cierre automático está desactivado',
      displayDurationDisabledHint: 'Mientras el cierre automático esté desactivado, no ocurre nada al cumplirse esta duración. El valor permanece guardado y vuelve a tener efecto en cuanto se reactiva el cierre automático.',
    },
  },

  printserver: {
    title:              'Servidor de impresión',
    subtitle:           'Servidores de impresión conectados de esta empresa',
    subtitleAllCompanies: 'Servidores de impresión conectados de todas las empresas',
    subtitleOwnCompanies: 'Servidores de impresión conectados de sus empresas',
    add:                'Añadir servidor de impresión',
    empty:              'Aún no hay servidores de impresión creados',
    emptyHint:          'Añada el primer servidor de impresión.',
    name:               'Nombre',
    uuid:               'UUID',
    uuidCopy:           'Copiar UUID',
    uuidLabel:          'UUID (generado automáticamente)',
    uuidHint:           'Una denominación para las personas, no un valor de configuración: el demonio no lee el UUID. Para la configuración vale el ID de documento.',
    documentId:         'ID de documento',
    documentIdHint:     'El demonio lee este identificador como PRINTSERVER_ID de su archivo .env. Se asigna al crear el servidor y no se puede modificar.',
    documentIdPending:  'El identificador se crea al guardar.',
    ipAddress:          'Dirección IP',
    anydeskId:          'ID de AnyDesk',
    anydeskIdMissing:   'El servidor de impresión comunica el ID de AnyDesk al iniciarse. Si falta, el equipo todavía ejecuta un software más antiguo que no lo comunica, o bien AnyDesk no está instalado en él o el ID no se puede leer.',
    company:            'Empresa',
    status:             'Estado',
    connectedSince:     'Conectado desde',
    lastContact:        'Último contacto',
    connectedMins:      'Conectado durante {n} min.',
    connectedHrs:       'Conectado durante {h} h {m} min.',
    lessThan1Min:       '< 1 min.',
    lastContactSec:     'hace {n} seg.',
    lastContactMin:     'hace {n} min.',
    lastContactHr:      'hace {n} h.',
    nodeVersion:        'Versión de Node.js',
    appVersion:         'Versión de la app',
    printerCount:       'Impresoras conectadas',
    printerCountValue:  '{n}',
    printerCountAtLeast:'al menos {n}',
    printerCountAtLeastHint: 'La lista de impresoras solo está cargada página por página ({count} por página): la cifra es un límite inferior. Puede haber más impresoras asignadas a este servidor de impresión; cargue más.',
    printerCountUnknownHint: 'La lista de impresoras aún no está disponible. La cifra aparece en cuanto se haya cargado.',
    runtimeFieldPending:'El servidor de impresión comunica este campo al cambiar de estado (inicio o parada). Los equipos con software más antiguo aún no lo comunican: el valor aparece tras el próximo reinicio.',
    updateAvailable:    'Actualización disponible: v{v}',
    restartControl:     'Control de reinicio',
    restartManual:      'Reinicio manual',
    restartHint:        'Envía un comando de reinicio a la aplicación Node.js en la Raspberry Pi.',
    restartAfter:       'Reiniciar después de (minutos)',
    restartNow:         'Reiniciar ahora',
    restarting:         'Reiniciando …',
    // ⚠ `restartSent` ist am 2026-09-18 mit T-M41.9 in allen sechs Sprachen
    // ENTFALLEN; die Begründung steht am selben Ort in `de.ts`.
    // NUEVO 2026-09-18 (T-M41.9): el acuse del documento en vivo sustituye al
    // mensaje de éxito tras el clic — dos marcas de tiempo, ningún veredicto.
    restartRequested:        'Reinicio solicitado el {t}',
    restartNotAcknowledged:  'El dispositivo aún no ha confirmado.',
    restartExecuted:         'Ejecutado por el dispositivo el {t}',
    restartReconnected:      'Reconectado desde {t}',
    autoRestartDelayHint: 'El cambio surte efecto en el próximo inicio del launcher en el dispositivo — igual que la hora de reinicio. 0 = sin intervalo.',
    autoRestart:        'Reinicio automático',
    autoRestartHint:    'La app se reiniciará automáticamente después de este intervalo. 0 = desactivado.',
    autoRestartDisabled:'El reinicio automático está desactivado.',
    autoRestartEnabled: 'La app se reiniciará cada {n} minutos.',
    connectionInfo:     'Información de conexión',
    connectionHint:     'La Raspberry Pi actualiza la IP, versión y estado automáticamente mediante Firestore heartbeat.',
    deleteTitle:        '¿Eliminar servidor de impresión?',
    deleteConfirm:      '¿Desea realmente eliminar {name}?',
    cannotUndoFull:     '¿Desea realmente eliminar «{name}»? Esta acción no se puede deshacer.',
    new:                'Nuevo servidor de impresión',
    stammdaten:         'Datos maestros',
    assignCompany:      'Asignar empresa',
    noCompany:          '— Sin empresa asignada —',
    companyHint:        'El servidor de impresión solo aparecerá para los usuarios de esta empresa.',
    companyPreset:      'Preseleccionado',
    companySearch:      'Buscar empresa …',
    companySelect:      'Seleccionar empresa',
    companyNoMatch:     'No se ha encontrado ninguna empresa.',
    cascadeTitle:       'Las impresoras pierden su servidor de impresión',
    cascadeText:        'Impresoras asignadas a este servidor de impresión ({count}): {names}. Pierden la asignación y no aceptan más trabajos hasta que se les asigne un servidor de impresión.',
    cascadeConfirm:     'Quitar la asignación y continuar',
    companyRequired:    'Asigne una empresa. Si el servidor de impresión ya no debe pertenecer a ninguna empresa, elimínelo.',
    infoCard:           'Info',
    piSetup:            'Configuración de Raspberry Pi',
    piSetupHint:        'Introduzca este identificador en el archivo .env del demonio de la Raspberry Pi:',
    piSetupPending:     'Guarde primero el servidor de impresión. Después aparecerá aquí el identificador para el archivo .env del demonio de la Raspberry Pi.',
    settingsTitle:      'Todos los servidores de impresión configurados – haga clic para abrir',
    settingsNoCompany:  '— Sin empresa —',
    settingsAddFirst:   'Añadir primer servidor de impresión',
    location:           'Ubicación',
    noLocation:         '— Sin ubicación asignada —',
    locationHint:       'Asigna el servidor de impresión a una ubicación.',
  },

  locations: {
    title:            'Ubicaciones',
    subtitle:         'Todas las ubicaciones de esta empresa',
    add:              'Añadir ubicación',
    empty:            'Aún no hay ubicaciones creadas',
    emptyHint:        'Añada la primera ubicación de esta empresa.',
    name:             'Nombre de la ubicación',
    namePlaceholder:  'p. ej. Sede principal Zúrich',
    new:              'Nueva ubicación',
    edit:             'Editar',
    autoUpdate:       'Actualización automática',
    autoUpdateOn:     'Activa',
    paused:           'En pausa',
    updateSection:    'Actualización automática',
    updatePaused:     'Pausar actualización',
    updatePausedHint: 'Suspende la actualización automática de los servidores de impresión de esta ubicación.',
    updateChannel:    'Canal de actualización',
    channelStable:    'Estable',
    channelBeta:      'Beta',
    pinnedVersion:    'Versión fijada',
    pinnedVersionHint:'Dejar vacío para la versión más reciente del canal elegido.',
    latest:           'Más reciente',
    deleteTitle:      '¿Eliminar la ubicación?',
    deleteConfirm:    '¿Seguro que desea eliminar {name}?',
  },

  jobs: {
    title:          'Trabajos de impresión',
    subtitle:       'Todos los trabajos de impresión de esta empresa',
    new:            'Nuevo trabajo',
    empty:          'No hay trabajos de impresión disponibles.',
    emptyFiltered:     'Ninguno de los trabajos cargados coincide con los filtros activos.',
    emptyFilteredHint: 'Se pueden cargar más trabajos abajo.',
    id:             'ID de trabajo',
    printer:        'Impresora',
    register:       'Caja',
    status:         'Estado',
    createdAt:      'Creado el',
    updatedAt:      'Última actualización',
    payload:        'Payload',
    create:         'Crear trabajo de impresión',
    send:           'Enviar trabajo de impresión',
    sending:        'Creando …',
    selectRegister: 'Seleccionar caja …',
    payloadLabel:   'JSON Payload (formato Payfix)',
    loadExample:    'Cargar ejemplo',
    invalidJson:    'JSON no válido. Por favor, compruébelo.',
    created:        'Trabajo de impresión creado',
    sourcePayfix:   'Payfix',
    sourceDashboard:'Panel',
    source:          'Origen',
    type:            'Tipo',
    typePrintjobs:   'Trabajos de impresión',
    typeReceipts:    'Recibos',
    statusAll:       'Todos',
    allPrinters:     'Todas las impresoras',
    allPrintservers: 'Todos los servidores de impresión',
    cashier:         'Empleado',
    positions:       'Artículos',
    total:           'Total',
    received:        'Recibido',
    printed:         'Impreso',
    paymentMethod:   'Método de pago',
    items:           'Art.',
    posName:         'Artículo',
    posQty:          'Cantidad',
    posUnit:         'Precio unitario',
    posTotal:        'Total',
    subtotal:        'Subtotal',
    tax:             'IVA',
    noItems:         'No hay artículos disponibles.',
    resend:          'Reenviar',
    deleteTitle:     '¿Eliminar el trabajo de impresión?',
    deleteConfirm:   '¿Seguro que quieres eliminar el trabajo {id}?',
    loadMore:          'Cargar más trabajos',
    loadingMore:       'Cargando …',
    loadedCount:       '{count} trabajos cargados',
    endOfList:         'Fin de la lista: todos los trabajos están cargados.',
    loadMoreError:     'Error al cargar más trabajos.',
    liveFirstPageOnly: 'Solo la primera página se actualiza en directo.',
    device:          'Dispositivo',
    deleteError:     'Error al eliminar.',
    resendError:     'El reenvío ha fallado. El trabajo no se ha creado.',
    resendNoPrintserver: 'Reenvío no posible: el canal no tiene ningún servidor de impresión asignado (los canales de pantalla no se pueden imprimir).',
    deliveryStatus:  'Estado de entrega',
    printerName: {
      idHint:         'Identificador de impresora: {id}',
      unresolved:     'Nombre no resoluble',
      unresolvedHint: 'No hay ningún canal con este identificador en la lista de impresoras cargada; probablemente se eliminó. Identificador: {id}',
      notLoaded:      'Nombre no cargado',
      notLoadedHint:  'La lista de impresoras solo está cargada página por página, por eso el nombre de este canal todavía no aparece. Esto no indica si el canal todavía existe: cargue más impresoras. Identificador: {id}',
    },
    workStatus: {
      label:              'Estado de preparación',
      columnHint:         'Segunda dimensión de estado, independiente: solo los pedidos (comandas) llevan un estado de preparación. Los tickets de caja no llevan ninguno, por eso su campo permanece vacío. Solo se muestra en los canales con la vista Kitchen TV activada; en todas las demás filas el campo permanece vacío igualmente: en el detalle del trabajo el valor sigue visible allí en cuanto difiere de «Abierto».',
      open:               'Abierto',
      inPreparation:      'En preparación',
      ready:              'Listo para recoger',
      done:               'Finalizado',
      unknown:            'Desconocido',
      unknownHint:        'Este valor no forma parte del vocabulario previsto.',
      notPrintedDoneHint: 'No es una contradicción: la entrega y la preparación son dos indicaciones distintas. El trabajo nunca llegó a su destino, pero se cerró operativamente (de forma automática al cabo de cuatro horas).',
      readOnly:           'Solo visualización: el estado de preparación no se cambia aquí.',
    },
    // Omisión registrada en el ticket (REQ-PR-037, complemento REQ-DM-030,
    // T-M11.12).
    omitted: {
      badge:       'Ticket incompleto',
      badgeHint:   'El trabajo se entregó, pero el modelo de impresora no pudo ejecutar algunos comandos del ticket. El detalle desplegado indica qué se omitió.',
      title:       'Comandos no ejecutados',
      position:    'Posición',
      opcode:      'Opcode',
      opcodeNone:  'ningún comando concreto',
      reasonLabel: 'Motivo',
      unknownHint: 'Este valor no forma parte del vocabulario previsto.',
      reason: {
        unsupportedByModel: 'No admitido por el modelo de impresora',
        emptyPayload:       'Sin datos útiles',
        invalidParameter:   'Parámetro no válido',
        unflushedBuffer:    'Búfer de línea no emitido',
        unknownOpcode:      'Comando de impresión desconocido',
        logoUnreadable:     'Logo no imprimible',
        unknown:            'Desconocido',
      },
      detail: {
        cut:      'Corte completo',
        textline: 'Búfer de línea',
        unknown:  'Desconocido',
      },
    },
    deliveredWithoutPrint: {
      badge:     'Entregado sin impresión',
      badgeHint: 'Este trabajo no se imprimió de forma intencionada: el canal muestra las comandas solo en pantalla. Se considera entregado en el momento de su recepción y por eso no lleva ninguna hora de impresión.',
      title:     'Entregado sin impresión',
      timeLabel: 'Entregado (sin impresión)',
    },
    deliveryConfirmation: {
      badge:     'Entregado sin confirmación de la impresora',
      badgeHint: 'Este modelo de impresora no confirma la impresión; solo se midió la transmisión.',
    },
    // Vista previa del contenido del recibo (REQ-OPS-060, T-M29.3) — solo
    // lectura y expresamente NO una vista previa de impresión. Ningún comando
    // se omite en silencio (REQ-PR-020).
    belegVorschau: {
      title:               'Contenido del recibo (vista previa)',
      abweichungsHinweis:  'No es una vista previa de impresión: el recibo impreso puede diferir de esto. El ancho de línea, el tamaño del texto y las imágenes se generan solo en la impresora.',
      u220Hinweis:         'Este recibo usa el lenguaje de comandos de la TM-U220. No existe vista previa para él — los mismos números de comando significan allí otra cosa, una representación sería adivinada en lugar de leída.',
      leerHinweis:         'Este recibo no contiene comandos de impresión.',
      platzhalter: {
        align:           'Alineación',
        textSize:        'Tamaño del texto',
        cut:             'Corte',
        qr:              'Código QR',
        image:           'Imagen',
        textEmpty:       'Comando de texto sin contenido',
        unknown:         'Comando desconocido {opcode} en la posición {position}',
        unknownNoOpcode: 'Comando sin número en la posición {position}',
      },
    },
  },

  settings: {
    title: 'Configuración',

    company: {
      title:            'Empresas',
      subtitle:         'Todas las empresas registradas',
      eyebrow:          'Configuración · Empresa',
      add:              'Añadir empresa',
      empty:            'Aún no hay empresas creadas.',
      name:             'Nombre de empresa',
      nameLabel:        'Nombre de empresa *',
      email:            'Correo electrónico',
      phone:            'Teléfono',
      address:          'Dirección',
      city:             'Ciudad',
      zip:              'Código postal',
      country:          'País',
      logo:             'Logo',
      description:      'Descripción',
      descriptionHint:  'Notas internas …',
      companyData:      'Datos de la empresa',
      bonSettings:      'Configuración de tickets',
      bonLogo:          'Logo del ticket',
      bonLogoHint:      'Aparece en la parte superior del recibo del cliente y del recibo de anulación, en la cuenta provisional según el interruptor de abajo, no en cierres ni en impresoras TM-U220. PNG, JPG o SVG, máx. 2 MB; se reduce al ancho de impresión y se imprime en blanco y negro.',
      bonLogoDrop:      'Suelte el logo aquí o haga clic para seleccionarlo',
      // T-M51.4 (REQ-DM-010a Praez. 1 (2)/(4)): Meldungen der Logo-Erfassung,
      // die Beschriftung der Druckvorschau und der Hinweis unter Schlusstext
      // und QR-Code-URL.
      bonLogoFileTooLarge:   'El archivo supera los 2 MB.',
      bonLogoResultTooLarge: 'Incluso reducido, el logo es demasiado grande para guardarlo. Elija un archivo más sencillo.',
      bonLogoNotImage:       'No se pudo leer el archivo como imagen.',
      bonLogoPrintPreview:   'Vista previa de impresión (blanco y negro)',
      bonFooterQrHint:       'Aparecen al final del recibo del cliente, en la cuenta provisional según los interruptores de abajo, no en recibos de anulación ni cierres, y no en impresoras TM-U220.',
      // T-M54.5 (REQ-DM-010a Praez. 2 (4)): Kartenueberschrift und die drei
      // Schalter der Zwischenrechnung mit ihrem Hinweis.
      receiptSettings:       'Configuración de recibos',
      interimReceiptLogo:    'Imprimir logo en la cuenta provisional',
      interimReceiptFooter:  'Imprimir texto final en la cuenta provisional',
      interimReceiptQr:      'Imprimir código QR en la cuenta provisional',
      interimReceiptHint:    'Se aplica a la cuenta provisional de la caja, en impresoras Epson y Sunmi, no en impresoras TM-U220. Lo que no esté introducido arriba tampoco se imprime en la cuenta provisional.',
      bonFooter:        'Pie de ticket',
      qrUrl:            'URL del código QR',
      usersSection:     'Usuarios',
      usersSubtitle:    'Usuarios de esta empresa y sus permisos de edición',
      addUser:          'Añadir usuario',
      noUsers:          'Aún no hay usuarios asignados',
      userCol:          'Usuario',
      emailCol:         'Correo electrónico',
      removeUser:       '¿Quitar usuario?',
      removeUserConfirm:'¿Desea quitar a este usuario de la empresa?',
      existingUser:     'Usuario existente',
      inviteByEmail:    'Invitar por correo electrónico',
      userSearch:       'Buscar usuarios …',
      noUsersFound:     'No se encontraron usuarios',
      inviteSent:       '¡Invitación enviada a {email}!',
      inviteEmailHint:  'El usuario recibirá un correo con un enlace para establecer su contraseña.',
      systemRole:       'Rol del sistema',
      roleUser:         'Usuario',
      roleAdmin:        'Administrador',
      deleteTitle:      '¿Eliminar empresa?',
      deleteConfirm:    '¿Desea realmente eliminar {name}?',
      cannotUndoFull:   '¿Desea realmente eliminar «{name}»? Esta acción no se puede deshacer.',
      payfixId:         'ID de cliente Payfix',
      payfixIdHint:     'Asignado por Payfix y no editable.',
      receiptFooter:    'Texto final del recibo',
      footerPlaceholder:'¡Gracias por su compra!',
      alarmCenter:      'Central de alarmas',
      alarmSectionSub:  'Notificaciones automáticas en caso de problemas',
      emailAlarm:       'Alarma por correo',
      emailAlarmHint:   'Notificaciones por correo electrónico',
      alarmWhen:        '¿Cuándo se debe alertar?',
      triggerQueueOffline:      'Cola sin conexión',
      triggerQueueOfflineDesc:  'Notificación cuando la cola del servidor de impresión se desconecta',
      triggerNotPrinted:        'Trabajo de impresión no impreso (10 min)',
      triggerNotPrintedDesc:    'Notificación cuando un ticket no se ha impreso después de 10 minutos',
      triggerPrinterOffline:    'Fallo de impresora',
      // `alarmOnPrinterOffline` traegt ALLE Drucker-Stufen, nicht nur `offline`
      // (T-M42.10); bis zum 2026-09-26 lautete der Text „Drucker Offline“.
      triggerPrinterOfflineDesc:'Notificación para cada nivel de alarma activado en la impresora (sin conexión, error, papel casi agotado, tapa abierta, sin papel)',
      // T-M42.10 Teil (b): Alarmierung nicht eingerichtet (utils/alarmEinrichtung.ts).
      alarmNotSetUp:             'Alarmas no configuradas',
      alarmNotSetUpNoType:       'No hay ningún tipo de alarma activado. Actualmente no se envía ninguna alarma para esta empresa.',
      alarmNotSetUpNoRecipients: 'No hay ningún destinatario: active la alarma por correo electrónico e introduzca al menos una dirección. Hasta entonces no se envía ninguna alarma para esta empresa.',
      alarmNotSetUpSavedState:   'Es determinante el estado guardado.',
    },

    users: {
      title:           'Usuarios',
      subtitle:        'Todos los usuarios de esta empresa',
      eyebrow:         'Configuración · Usuarios',
      add:             'Invitar usuario',
      empty:           'Aún no hay usuarios disponibles.',
      searchEmpty:     'No se encontró ningún usuario para «{search}».',
      name:            'Nombre',
      email:           'Correo electrónico',
      role:            'Rol',
      status:          'Estado',
      lastLogin:       'Último acceso',
      data:            'Datos del usuario',
      emailHint:       'El correo no puede modificarse después de la creación.',
      inviteHint:      'El usuario recibirá un correo de invitación para establecer su contraseña.',
      roleAccess:      'Rol y acceso',
      internalNote:    'Nota interna',
      internalNotePH:  'Responsabilidades, departamento …',
      noAccount:       'No hay cuenta de inicio de sesión',
      noAccountHint:   'Este usuario fue creado sin una cuenta de Firebase Auth y no puede iniciar sesión. Envíe un correo de invitación para corregirlo.',
      inviteSent:      '¡Invitación enviada!',
      inviteSentHint:  'Se envió un correo a {email}. El usuario puede usarlo para establecer su contraseña.',
      deleteTitle:     '¿Eliminar usuario?',
      deleteConfirm:   '¿Desea realmente eliminar «{name}»? El usuario perderá el acceso inmediatamente.',
      invite:          'Enviar invitación',
      invited:         'Invitado',
      companies:       'Empresas',
      companiesHint:   'El usuario ve y gestiona los datos de estas empresas.',
      // Para el rol `admin` este aviso sustituye la lista de casillas
      // (REQ-SEC-030 prec. 1 (c), REQ-SEC-027 (a) — T-M38.4).
      companiesAdminHint: 'Los administradores tienen acceso a todas las empresas; no es necesaria ninguna asignación.',
      companiesNone:   'Aún no está asignado a ninguna empresa.',
      companySearch:   'Buscar empresa …',
      companyNoMatch:  'No se ha encontrado ninguna empresa.',
      companyLimit:    'Un usuario puede tener como máximo {max} empresas. Retire primero una empresa.',
      companyRequired: 'Seleccione al menos una empresa para la invitación.',
      invitations:     'Invitaciones pendientes',
      openInvitation:  'Invitación pendiente',
      validUntil:      'Válida hasta el {date}',
      expiredOn:       'Caducada el {date}',
      reinvite:        'Invitar de nuevo',
      inviteFailed:    'No se pudo enviar la invitación.',
    },

    smtp: {
      title:            'Correo SMTP',
      subtitle:         'Configuración para el envío de correos',
      infoText:         'Estos ajustes SMTP son para correos personalizados. Firebase Auth envía correos del sistema de forma independiente.',
      serverConnection: 'Conexión al servidor',
      authentication:   'Autenticación',
      sender:           'Remitente',
      statusCard:       'Estado',
      encryption:       'Cifrado',
      lastSaved:        'Guardado por última vez',
      testSentTo:       '¡Correo de prueba enviado a {email}!',
      host:             'Host SMTP',
      port:             'Puerto',
      user:             'Usuario',
      password:         'Contraseña',
      fromEmail:        'Correo del remitente',
      fromName:         'Nombre del remitente',
      secure:           'Usar SSL / TLS',
      test:             'Enviar correo de prueba',
      testSent:         '¡Correo de prueba enviado con éxito!',
      save:             'Guardar configuración SMTP',
      noEncryption:     'Sin cifrado (Puerto 25)',
      starttls:         'STARTTLS (Puerto 587)',
      tls:              'SSL/TLS (Puerto 465)',
      activeLabel:      'SMTP activo',
      activeNotice:     'Los correos de invitación y las notificaciones del sistema se envían a través de esta configuración SMTP.',
      activeFallback:   'Si SMTP no está configurado, se utiliza automáticamente Firebase Authentication como alternativa.',
      secretBadge:      'Guardado como secreto de Firebase',
      secretHint:       'Este secreto no se guarda en la base de datos y nunca se carga en el navegador. Se establece en el servidor, en el proyecto de Firebase, con el comando de abajo. Introduzca el valor cuando se le pida o páselo por una tubería con printf %s, nunca con echo: echo añade un salto de línea, que se guarda sin cambios en el secreto.',
    },

    api: {
      eyebrow:          'Ajustes · API',
      title:            'Tokens de API',
      subtitle:         'Tokens de acceso para la API REST pública',
      tokensTitle:      'Tokens de API',
      tokensSubtitle:   'Tokens para el acceso API externo — de esta empresa y globales',
      generate:         'Generar token',
      noCompany:        'Seleccione primero una empresa.',
      empty:            'Todavía no hay tokens de API.',
      colScope:         'Alcance',
      scopeGlobal:      'Global',
      scopeCompany:     'Empresa',
      scopeGlobalHint:  'Válido para todas las empresas.',
      scopeCompanyHint: 'Válido solo para esta empresa.',
      globalLabel:      'Token global',
      globalHint:       'Válido para todas las empresas en lugar de solo para esta. Úselo únicamente para accesos internos y asígnele un nombre que identifique a quien lo utiliza.',
      revokeGlobalHint: 'Este token es válido para todas las empresas. Tras la revocación, todas las empresas pierden el acceso a través de él de inmediato.',
      colName:          'Nombre',
      colPrefix:        'Prefijo',
      colStatus:        'Estado',
      colCreated:       'Creado',
      colExpires:       'Válido hasta',
      colLastUsed:      'Último uso',
      statusActive:     'Activo',
      statusRevoked:    'Revocado',
      neverExpires:     'Sin caducidad',
      revoke:           'Revocar token',
      tokenCreated:     '¡Token generado, guárdelo ahora!',
      tokenOnceHint:    'El token solo se muestra una vez. Cópielo en un lugar seguro.',
      connectionTitle:  'Conexión',
      authLabel:        'Autenticación',
      contentTypeLabel: 'Content-Type',
      connectionNote:   'Envíe el token en cada solicitud en el encabezado Authorization como Bearer token.',
      createTitle:      'Generar un nuevo token de API',
      createBody:       'Opcionalmente asigne un nombre y una fecha de caducidad.',
      nameLabel:        'Nombre (opcional)',
      namePlaceholder:  'p. ej. Integración Payfix',
      expiresLabel:     'Fecha de caducidad (opcional)',
      expiresHint:      'Deje vacío para un token sin caducidad.',
      revokeTitle:      '¿Revocar el token?',
      revokeBody:       'El token «{name}» se revocará de forma irreversible. Todas las integraciones que lo usen perderán el acceso inmediatamente.',
      revokeConfirm:    'Sí, revocar',
    },
  },

  companySelect: {
    title:    'Seleccionar empresa',
    subtitle: 'Seleccione una empresa para continuar.',
    search:   'Buscar empresa …',
    empty:    'No se encontraron empresas.',
    continue: 'Continuar',
    notFound: 'No se encontró ninguna empresa para «{query}»',
    // ⚠ ENTFALLEN AM 2026-08-22 (T-M24.3, REQ-OPS-058 (2)) — die vier Saetze
    // der Nachlade-Leiste (`limitReached`, `loadMore`, `loadedCount`,
    // `endOfList`) sind in allen sechs Sprachen zurueckgenommen; der deutsche
    // Wortlaut steht in `de.ts`. Die Firmen-Auswahl laedt alle Firmen auf
    // einmal. Die gleichnamigen Saetze unter `printers.*` bleiben stehen.
  },

  location: {
    offline: 'Ubicación sin conexión',
  },

  fastline: {
    cameraOpen:    'Abrir cámara',
    orderNumber:   'Número de pedido',
    search:        'Buscar',
    scan:          'Escanear',
    scanQr:        'Escanear código QR',
    // El teclado táctil de la introducción manual (REQ-SC-099, T-M23.3).
    keypadOpen:      'Introducir código',
    keypadTitle:     'Introducir el código manualmente',
    keypadHint:      'Alternativa cuando el código QR no se puede leer. El escáner y la cámara siguen siendo la vía normal.',
    keypadSearch:    'Buscar pedido',
    keypadBackspace: 'Borrar el último carácter',
    // Las dos pantallas de resultado (REQ-SC-100, T-M23.4).
    pickedUpTitle:     'Recogido',
    pickedUpDone:      'El pedido está cerrado y se ha retirado de la lista.',
    pickedUpAutoClose: 'Esta ventana se cierra sola en {seconds} segundos.',
    notFoundTitle:     'Pedido no encontrado',
    notFoundText:      'Este código es desconocido.',
    notFoundRescan:    'Escanear de nuevo',
    notFoundManual:    'Introducir el código manualmente',
    scanHint:      'Coloque el código QR dentro del marco',
    // Respuesta del escaneo movida a `screen.*` con T-M12.21 (REQ-SC-082).

    // La única acción principal de la ventana de recogida (REQ-SC-098 (4)).
    pickUp:        'Recoger',
    scannerReady:     'Escáner listo',
    scannerReadyHint: 'Escanee el código QR del recibo — el pedido se abre solo.',
  },

  kitchen: {
    toCook:           'Por cocinar',
    tickets:          'Tickets',
    allDone:          'Todo listo',
    openItems:        'Artículos abiertos',
    open:             'Abierto',
    inProgress:       'En proceso',
    start:            'Iniciar',
    markReady:        'Listo para recoger',
    done:             'Listo',
    emptyOpen:        'No hay pedidos abiertos',
    emptyInProgress:  'No hay pedidos en proceso',
    emptyReady:       'No hay pedidos listos para recoger',
    emptyOrders:      'No hay pedidos',
    doneAll:          '¡Todo listo!',
    actionFailed:     'No se ha guardado. Vuelve a tocar.',
    actionStale:      'El pedido ha cambiado. La vista se actualiza sola.',
    actionExpired:    'La sesión de esta pantalla ha caducado. Recarga la página.',
    // Agrupación e inicio por plato (REQ-SC-068, T-M12.8). El identificador del
    // plato es una CADENA que se usa literalmente — `Plato 2`, también `Plato Ürli`.
    gangLabel:        'Plato {gang}',
    startGang:        'Iniciar plato',
    // Artikel-Countdown (REQ-SC-071): Aufschrift der Startschaltflaeche.
    timerStart:       '{minutes} min',
    // Modificaciones posteriores (REQ-SC-072, T-M12.7): rótulo del botón
    // rojo cuando la cantidad resultante cae a cero o por debajo.
    fullyCancelled:   'Totalmente anulado',
    // Diálogo de resultado del escaneo de recogida (REQ-SC-073, T-M12.10). El
    // MOTIVO EXPLÍCITO de REQ-SC-087 está desde T-M12.54 en
    // `screen.scanNotReady`: es la misma frase en las tres vistas.
    tableNumber:      'Mesa {number}',
    scanReceived:     'Recepción',
    scanNoDetail:     'Los detalles de este pedido no están disponibles en esta pantalla.',
    // Estado de la tarjeta en la vista Fastline (REQ-SC-097 (2)) — solo
    // visualización; el estado de tratamiento en Firestore sigue siendo `open`.
    waitingForPickupScan: 'Esperando el escaneo de recogida',
  },

  screen: {
    keyPrompt:      'Introducir clave de pantalla',
    keyPlaceholder: 'Clave de pantalla',
    connect:        'Conectar',
    connecting:     'Conectando …',
    invalidKey:     'Clave de pantalla no válida.',
    notPrinted:     'Ticket aún no impreso',
    limitReached:   'Solo se muestran los {count} pedidos más recientes.',
    // Vista desactivada (REQ-SC-079, T-M12.19).
    viewDisabledTitle:       'Esta vista está desactivada',
    viewDisabledKitchenTv:   'La Kitchen TV no está activada para este canal.',
    viewDisabledAbholscreen: 'La pantalla de recogida no está activada para este canal.',
    viewDisabledChannel:     'Canal: {name}',
    viewDisabledHelp:        'Puede activar la vista para este canal en «Impresoras» en el panel de control.',
    // Toma del modo de pantalla (REQ-SC-104 (5), T-M25.3) — por canal hay
    // exactamente un modo activo; la pantalla recién abierta nombra el modo
    // activo y solo escribe tras la confirmación.
    modeNameNormal:   'Kitchen TV',
    modeNameLight:    'Kitchen TV Light',
    modeNameFastline: 'Fastline',
    takeoverTitle:    'Hay otro modo activo',
    takeoverWarning:  'En este canal se está ejecutando «{active}». Si inicia «{own}» aquí, «{active}» se desactivará.',
    takeoverIdle:     'Esta pantalla todavía no ha tomado «{own}».',
    takeoverConfirm:  'Iniciar «{own}» aquí',
    takeoverRunning:  'Tomando el control …',
    takeoverHint:     'Mientras no confirme no cambia nada: la otra pantalla sigue funcionando.',
    // Respuesta del escaneo de recogida (REQ-SC-082, T-M12.21) — compartida por las tres pantallas.
    alreadyPickedUp:       'Ya recogido',
    alreadyPickedUpAt:     'Recogido el {time}',
    alreadyPickedUpNoTime: 'Hora no registrada',
    scanFound:             'Pedido encontrado',
    scanCompleted:         'Completado',
    scanNotFound:          'No se encontró ningún pedido coincidente',
    scanError:             'Error de escaneo',
    scanNotReady:          'El escaneo queda registrado. El cierre solo se realiza desde «Listo para recoger».',
    // Introducción y escaneo en la pantalla de recogida (REQ-SC-012, T-M12.23).
    pickupPrompt: 'Introduzca o escanee el número de pedido',
    pickupNumber: 'Número de pedido',
    pickupSubmit: 'Recoger',
    // Cierre colectivo (REQ-SC-083, T-M12.22). La confirmación debe nombrar qué
    // se cierra y cuántos pedidos — y decir expresamente que no se imprime nada.
    completeAll:        'Cerrar todos',
    completeAllTitle:   '¿Cerrar todos los pedidos?',
    completeAllBody:    'Se cerrarán {count} pedidos en «En proceso» y «Listo para recoger». Es una limpieza de la pantalla: no se imprime nada ni se emite ningún recibo.',
    completeAllChunks:  'Hay más de {max} pedidos. Se cerrarán en {calls} pasos; si un paso falla, los pedidos de los pasos siguientes quedan abiertos.',
    completeAllConfirm: 'Sí, cerrar {count}',
    completeAllDone:    '{count} pedidos cerrados.',
    completeAllNoScan:  'No recogidos con un código QR: {count} pedidos no tienen ningún escaneo de recogida. ¿Cerrarlos igualmente?',
    // Etiqueta de origen en el canal Fast Line (REQ-SC-095). «OrderMood» es
    // un nombre propio y se mantiene igual en todos los idiomas.
    originOrderMood: 'OrderMood',
    originRegister:  'Caja',
  },

  // ── Das Kennzeichen des Testsystems (T-M32.7, REQ-OPS-061) ────────────────
  // Der Streifen am oberen Rand der Verwaltungsoberflaeche. Uebersetzt wird
  // allein das WORT „Testsystem"; `{projektId}` ist ein technischer Name und
  // steht in jeder Sprache gleich (REQ-OV-002, REQ-OV-008).
  // Der Emulator-Wortlaut ist der Sonderfall des lokalen Entwicklungswegs: dort
  // lautet die Projekt-ID `printerque-prod`, weil sie beim Emulatorlauf nur die
  // Audience der ID-Token ist (REQ-OPS-064 (a)) — ohne den Zusatz stuende ein
  // Widerspruch auf dem Bildschirm.
  umgebung: {
    testBanner:         'SISTEMA DE PRUEBAS · {projektId}',
    testBannerEmulator: 'SISTEMA DE PRUEBAS · {projektId} · Emulador',
  },
}
